import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WhitepaperspageService } from '../../whitepaperspage.service';
import { CommonModule, ViewportScroller } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from 'src/app/shared/services/meta.service';

@Component({
  selector: 'app-whitepaper-article-hero',
  templateUrl: './whitepaper-article-hero.component.html',
  styleUrls: ['./whitepaper-article-hero.component.scss'],
  imports: [CommonModule],
})
export class WhitepaperArticleHeroComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  constructor(
    private whitePaperspageService: WhitepaperspageService,
    private router: Router,
    private meta: MetaService,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller
  ) {
    this.subscriptions = [];
    this.getUrl = this.router.url;
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  heroData: any;
  

  ngOnInit(): void {
    
  }
  ngOnChanges(): void {
    let data = this.pageData?.fields;
    if (data != null) {
      this.heroData = {
        header: data?.title,
        image: {
          url: data?.whitepapersAndReportsImage?.fields?.file?.url,
          alt: data?.whitepapersAndReportsImage?.fields?.title,
        },
        paragraph: data?.whitepapersAndReportsContent,
        button: {
          url: data?.button?.[0]?.fields?.redirectLink,
          text: data?.button?.[0]?.fields?.buttonText,
          target: data?.button?.[0]?.fields?.actionType,
        },
      };
      this.metaBody.title = data?.seoMetadataReference?.fields?.title || 'Verto: Cross-border payments platform for businesses';
      this.metaBody.description = data?.seoMetadataReference?.fields?.description || 'Verto: Cross-border payments platform for businesses across the globe.';
      this.metaBody.type = 'Blog Article';
      this.metaBody.url = this.getUrl;
      this.metaBody.image = data?.whitepapersAndReportsImage?.fields?.file?.url;
      this.meta.updateOG(this.metaBody);
      this.meta.updateMeta(data?.seoMetadataReference?.fields);
    }
  }
  public scrollTo(): void {
    this.viewportScroller.scrollToAnchor('downloadForm');
  }
}
